import _ from "lodash";
import { PRODUCT_MAP } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        productMap: _.cloneDeep(constants.PRODUCT_MAP_INPUT)
    }
}

const productMapReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PRODUCT_MAP.SET_PRODUCT_MAP_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case PRODUCT_MAP.SET_PRODUCT_MAP:
        case PRODUCT_MAP.SET_PRODUCT_MAP_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    productMap: action.productMap
                }
            })
        default:
            return state
    }
}

export default productMapReducer